module.exports = __webpack_public_path__ + "img/gameTimeBg.37be60e1.png";